import React from "react";
import { IoIosCall } from "react-icons/io";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa6";

const Footer = () => {
  return (
    <div className="w-full bg-[#101e2b] flex justify-center items-center py-[4rem]">
      <div className="container grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1  sm:gap-4 gap-[2rem] px-4 sm:px-0">
        <div>
          <img src={logo} alt="" className="w-[8rem]" />
        </div>
        <div className="flex flex-col gap-4">
          <h2 className="text-2xl text-white font-semibold">কোম্পানি</h2>
          <div className="flex flex-col gap-2">
            <Link
              to="/qs-academy/about/"
              className="text-[#bfbfbf] hover:text-[#22BEFF]"
            >
              আমাদের সম্পর্কে
            </Link>
            <Link
              to="/qs-academy/test-learning/teacher-traning"
              className="text-[#bfbfbf] hover:text-[#22BEFF]"
            >
              লাইফ কোচ ট্রেনিং
            </Link>
            <Link to="/" className="text-[#bfbfbf] hover:text-[#22BEFF]">
              ক্যারিয়ার / নিয়োগ বিজ্ঞপ্তি
            </Link>
            <Link to="/" className="text-[#bfbfbf] hover:text-[#22BEFF]">
              প্রাইভেসি পলিসি
            </Link>
            <Link to="/" className="text-[#bfbfbf] hover:text-[#22BEFF]">
              রিফান্ড পলিসি
            </Link>
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <h2 className="text-2xl text-white font-semibold">সার্ভিসেস</h2>
          <div className="flex flex-col gap-2">
            <Link
              to="/qs-academy/test/thought"
              className="text-[#bfbfbf] hover:text-[#22BEFF]"
            >
              QS রিভাইভ টেস্ট
            </Link>
            <Link
              to="/qs-academy/smart-school/"
              className="text-[#bfbfbf] hover:text-[#22BEFF]"
            >
              QS স্মার্ট স্কুল ফ্র্যাঞ্চাইজি
            </Link>
            <Link
              to="/qs-academy/test-learning/teacher-traning"
              className="text-[#bfbfbf] hover:text-[#22BEFF]"
            >
              QS স্মার্ট টিচার ট্রেনিং
            </Link>
            <Link
              to="/qs-academy/course/"
              className="text-[#bfbfbf] hover:text-[#22BEFF]"
            >
              কোর্সে’স
            </Link>
            <Link
              to="/qs-academy/bookstore/"
              className="text-[#bfbfbf] hover:text-[#22BEFF]"
            >
              বুক স্টোর
            </Link>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <h2 className="text-2xl text-white font-semibold">
           যোগাযোগ
          </h2>
          <div className="flex flex-col gap-2">
            <Link to="/" className="text-[#bfbfbf]">
              হোয়াটসঅ্যাপ:{" "}
              <span className="text-[#22BEFF]">01711055752</span>(24x7)
            </Link>
            <Link to="/" className="text-[#bfbfbf] ">
              দেশের বাহির থেকে:{" "}
              <span className="text-[#22BEFF]">01711055752</span>(24x7)
            </Link>
            <Link to="/" className="text-[#bfbfbf]">
              ইমেইল:
              <span className="text-[#22BEFF]"> support@qsacademybd.com</span>{" "}
            </Link>
            <Link to="/" className="text-[#bfbfbf]">
             ঠিকানা:
              <span className="text-[#22BEFF]"> রোড-০২, সেক্টর-১০, উত্তরা, ঢাকা।</span>{" "}
            </Link>
          </div>

          <div className="flex items-center gap-2">
            <Link
              to="https://www.facebook.com/qsacademybangladesh"
              target="_blank"
              className="w-[2rem] h-[2rem] bg-[#22BEFF] rounded-md flex items-center justify-center text-white"
            >
              <FaFacebookF />
            </Link>
            <div className="w-[2rem] h-[2rem] bg-[#22BEFF] rounded-md flex items-center justify-center text-white">
              <FaTwitter />
            </div>
            <div className="w-[2rem] h-[2rem] bg-[#22BEFF] rounded-md flex items-center justify-center text-white">
              <FaInstagram />
            </div>
            <div className="w-[2rem] h-[2rem] bg-[#22BEFF] rounded-md flex items-center justify-center text-white">
              <FaYoutube />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
